import React from 'react';

// Presentation only: request ownership and retry authority stay in the hook.
export default function AccessCodeLookupStatus({ lookup, testId }) {
  const { status, loading, refreshing, hasData, message, retry, canRetry } = lookup;
  if (status === 'ready' || status === 'missing') return null;
  return (
    <div className="my-1 text-xs text-stone-600" role="status" data-testid={testId}>
      {loading || refreshing ? (
        <span>{hasData ? 'Refreshing access information. Showing the last confirmed information, not yet refreshed.' : 'Checking access information…'}</span>
      ) : (
        <>
          <span>{message || `Access information unavailable.${hasData ? ' Showing the last confirmed information; it has not been refreshed.' : ''}`}</span>
          {canRetry && <button type="button" className="ml-2 underline font-medium" data-testid={`${testId}-retry`} onClick={retry}>Retry</button>}
        </>
      )}
    </div>
  );
}
